import { apiRootURL } from "./defaultSettings";
export const DOCUMENT_TITLE = "Démonstrateur | C@iA.parts ";

export const PROXY_PORT = {
    Opel: 3001,
    "07ZR": 3002,
    Michelin: 3003,
    Ford: 3004,
    RRG: 3005,
    GtEstimate: 8889,
};

export const dockApps = [
    "citroen",
    "ds",
    "opel",
    "peugeot",
    "misterauto",
    "eurorepar",
    "actia",
];

export const iframes = {
    citroen: "https://www.citroen.fr/accueil.html",
    ds: "https://www.dsautomobiles.fr/accueil.html",
    eurorepar: "https://www.eurorepar.fr/",
    misterauto: "https://www.mister-auto.com/",
    opel: process.env.REACT_APP_PROXY_SERVER_HOST + ":" + PROXY_PORT.Opel,
    peugeot: "http://www.peugeot.fr/accueil.html",
    actia: "https://www.actia.com/fr",
    back: "https://back.ia.parts/",
    diag: "https://box.ia.parts/",
    erp: "https://scoria.cloud/web",
    store: "https://appstore.ia.parts",
    visio: "https://meetbox.ia.parts",
    com: "https://com.ia.parts/",
    help: "https://uniflix.ia.parts/",
    tecrmi: "https://rmi-point-s.ia.parts",
};

export const iframePartSelector = {
    fr: "https://www.points.fr/gamme-points/pieces-techniques-consommables.html",
    en: "https://www.points.fr/gamme-points/pieces-techniques-consommables.html",
};

export const iframeCarSelector = {
    fr: "https://www.points.fr/espace-pro/flotte.html",
    en: "https://www.points.fr/espace-pro/flotte.html",
};

export const iframeContactSelector = {
    fr: "https://www.points.fr/reseau/devenir-adherent.html#tab5-Nous%20contacter",
    en: "https://www.points.fr/reseau/devenir-adherent.html#tab5-Nous%20contacter",
};

export const DIAG_OTHER_BRANDS = [
    { name: "C@iA", url: "https://run.ia.parts" },
    { name: "C@iA", url: "https://run.ia.parts" },
    { name: "C@iA", url: "https://run.ia.parts" },
    { name: "C@iA", url: "https://run.ia.parts" },
];

export const PLUS_MENU_APPS = [
    {
        id: 0,
        name: "C@iA",
        url: "https://run.ia.parts",
        img: `${apiRootURL}/media/logos/C@IA.png`,
    },
    {
        id: 1,
        name: "C@iA",
        url: "https://run.ia.parts",
        img: `${apiRootURL}/media/logos/C@IA.png`,
    },
    {
        id: 2,
        name: "C@iA",
        url: "https://run.ia.parts",
        img: `${apiRootURL}/media/logos/C@IA.png`,
    },
];

export const LEVAM_URL = "https://oem1.ia.parts/oem_point-s.html";

export const WORDPRESS_URL = "https://wp.ia.parts/point-s";

export const USE_KEYCLOAK = true;
